import { MenuItemProps } from './MainNavbar';

const menuConfig: MenuItemProps[] = [];

export default menuConfig;
